import abydos from "./assets/abydos.png";
import heim_bg from "./assets/heim-bg.png";
import abydos_bg2 from "./assets/abydos-bg2.png";
import meso from "./assets/meso.png";
import meso_bg from "./assets/meso-bg.png";
import fracture from "./assets/fracture.png";
import ks1icon from "./assets/ks1icon.png";
import fracture_bg from "./assets/fracture-bg.png";
import tortuga from "./assets/tortuga.png";
import tortuga_bg from "./assets/tortuga-bg.png";
import myradin from "./assets/myradin.png";
import myradin_bg from "./assets/myradin-bg.png";
import polygonia from "./assets/polygonia.png";
import polygonia_bg from "./assets/polygonia-bg.png";
import primus from "./assets/primus.png";
import primus_bg from "./assets/primus-bg.png";
import commetior from "./assets/commetior.png";
import commetior_bg from "./assets/commetior-bg.png";
import commetior_bg2 from "./assets/commetior-bg2.png";
import mtc from "./assets/mtc.png";
import mtc_bg from "./assets/mtc-bg.png";
import numint from "./assets/numint.png";
import abydos_game_bg from "./assets/abydos-game-bg.png";
import meso_game_bg from "./assets/meso-game-bg.png";
import algebra from "./assets/algebra.png";
import heim from "./assets/heim.png";
import minima from "./assets/minima.png";
import equitas from "./assets/equitas.png";
import equitas_bg from "./assets/equitas-bg.png";
import algebra_screenshot from "./assets/AlgebraScreenshot.jpg";
import caramella from "./assets/sweetplaneticon.png";
import caramella_screenshot from "./assets/mathsvocabpreview.jpg";
import phobia from "./assets/phobiaplaneticon.png";
import phobia_screenshot from "./assets/phobiapreview.jpg";
import ks1_screenshot from "./assets/ks1_bg.png";

import multgame from "./assets/Multiplication/MultiplicationLevel.png";
import spellinggame from "./assets/Spelling/SpellingLevel.png";
import addgame from "./assets/Addition/AdditionLevel.png";
import alggame from "./assets/Algebra/AlgebraLevel.png";
import fractgame from "./assets/Fractions/FractionsLevel.png";
import geogame from "./assets/Geometry/GeometryLevel.png";
import grammargame from "./assets/Grammar/GrammarLevel.png";
import measurementsgame from "./assets/Measurements/MeasurementLevel.png";
import multiplicationgame from "./assets/Multiplication/MultiplicationLevel.png";
import numberandplacegame from "./assets/NumberAndPlace/NumberAndPlaceLevel.png";
import statisticsgame from "./assets/Statistics/StatisticsLevel.png";



const games = [
  {
    backend_id: 25,
    id: 26,
    image: phobia,
    background: phobia_screenshot,
    trophies: 2,
    name: "Phobos",
    description: "Phonics",
    instructions:
      "Help Emile understand sounds on the monstrous planet of Phobos.",
    playable: true,
    game_type: "phonics",
    rating_background: "Grammar/grammar.gif",
    practice_background: grammargame,
    selection_background: "Phonics/phonicsmenu.gif",
    service_key: "phonics",
    animation_path: "Phonics/Animation"
  },
  {
    backend_id: 6,
    id: 10,
    image: heim,
    background: heim_bg,
    trophies: 2,
    name: "Heim",
    description: "Spelling",
    instructions:
      "Jump on a dragon boat with Emile and enter the missing runes.",
    playable: true,
    game_type: "spelling",
    rating_background: "Spelling/spelling_rating.gif",
    practice_background: spellinggame,
    selection_background: "Spelling/menu_spelling.gif",
    service_key: "spelling",
    animation_path: "Spelling/Animation"
  },
  {
    backend_id: 30,
    id: 38,
    image: heim,
    background: heim_bg,
    trophies: 2,
    name: "Heim",
    description: "Spelling Cup",
    instructions:
      "",
    playable: false,
    game_type: "spelling",
    rating_background: "Spelling/spelling_rating.gif",
    practice_background: spellinggame,
    selection_background: "Spelling/menu_spelling.gif",
    service_key: "spellingsats",
    animation_path: "Spelling/Animation"
  },
  {
    backend_id: 10,
    id: 13,
    image: myradin,
    background: myradin_bg,
    trophies: 2,
    name: "Myradin",
    description: "Grammar",
    instructions:
      "Follow the rules of grammar to make great spells and potions to find the hidden gems.",
    playable: true,
    game_type: "grammar",
    rating_background: "Grammar/grammar.gif",
    practice_background: grammargame,
    selection_background: "Grammar/menu_grammar.gif",
    service_key: "grammar",
    animation_path: "Grammar/Animation"
  },
  {
    backend_id: 26,
    id: 27,
    image: primus,
    background: primus_bg,
    trophies: 16,
    name: "Primus",
    description: "Number Sense",
    instructions:
      "Help Emile understand numbers",
    playable: true,
    game_type: "numbersense",
    rating_background: "NumberAndPlace/numplace.gif",
    practice_background: numberandplacegame,
    selection_background: "NumberAndPlace/menu_numplace.gif",
    service_key: "numbersense",
    animation_path: "NumberAndPlace/Animation"
  },
  {
    backend_id: 11,
    id: 14,
    image: tortuga,
    background: tortuga_bg,
    trophies: 11,
    name: "Tortuga",
    description: "Addition and Subtraction",
    instructions:
      "Find the knowledge gems hidden around the pirate planet of Tortuga.",
    playable: true,
    game_type: "addition",
    rating_background: "Addition/addition_rating.gif",
    practice_background: addgame,
    selection_background: "Addition/menu_addition.gif",
    service_key: "addition",
    animation_path: "Addition/Animation"
  },
  {
    backend_id: 14,
    id: 16,
    image: primus,
    background: primus_bg,
    trophies: 16,
    name: "Primus",
    description: "Place Value",
    instructions:
      "Emile has found Scrambler's home planet! Help Emile discover Scrambler's ancient past by learning the basics of place value.",
    playable: true,
    game_type: "numplace",
    rating_background: "NumberAndPlace/numplace.gif",
    practice_background: numberandplacegame,
    selection_background: "NumberAndPlace/menu_numplace.gif",
    service_key: "numplace",
    animation_path: "NumberAndPlace/Animation"
  },
  {
    backend_id: 31,
    id: 39,
    image: ks1icon,
    background: ks1_screenshot,
    trophies: 2,
    name: "Dinocorn",
    description: "Key Stage 1 Arithmetic",
    instructions:
      "",
    playable: true,
    game_type: "ks1",
    rating_background: "NumberAndPlace/numplace.gif",
    practice_background: numberandplacegame,
    selection_background: "KS1/menu_ks1.gif",
    service_key: "keystage1arithmetic",
    animation_path: "NumberAndPlace/Animation"
  },
  {
    backend_id: 5,
    id: 9,
    image: meso,
    background: meso_bg,
    trophies: 12,
    name: "Meso",
    description: "Multiplication",
    instructions: "Emile must deal with the gods of Multiplication & Division.",
    playable: true,
    game_type: "multiplication",
    rating_background: "Multiplication/multiplication_rating.gif",
    practice_background: multgame,
    selection_background: "Multiplication/menu_multiplication.gif",
    service_key: "timetables",
    animation_path: "Multiplication/Animation"
  },
  {
    backend_id: 19,
    id: 22,
    image: mtc,
    background: mtc_bg,
    trophies: null,
    name: "MTC",
    description: "Multiplication Tables Check",
    instructions: "Try the multiplication table check!",
    playable: true,
    game_type: "MTC",
    game_background: "background.png",
    selection_background: "background.png",
    service_key: "MTC"
  },
  {
    backend_id: 9,
    id: 12,
    image: fracture,
    background: fracture_bg,
    trophies: 22,
    name: "Fracture",
    description: "Fractions, Decimals and Percentages",
    instructions:
      "Emile needs to solve problems to stop the planet splitting into fractions.",
    playable: true,
    game_type: "fractions",
    rating_background: "Fractions/fractions.gif",
    practice_background: fractgame,
    selection_background: "Fractions/menu_fractions.gif",
    service_key: "fractions",
    animation_path: "Fractions/Animation"
  },
  {
    backend_id: 16,
    id: 21,
    image: commetior,
    background: commetior_bg2,
    trophies: 2,
    name: "Commetior",
    description: "Roman Numerals",
    instructions:
      "Emile is helping rebuild the Roman planet but needs help to convert their numerals for his blueprints.",
    playable: true,
    game_type: "romannumerals",
    rating_background: "Measurements/measurements.gif",
    practice_background: measurementsgame,
    selection_background: "Measurements/menu_measurements.gif",
    service_key: "romannumerals",
    animation_path: "Measurements/Animation"
  },
  {
    backend_id: 8,
    id: 11,
    image: polygonia,
    background: polygonia_bg,
    trophies: 18,
    name: "Polygonia",
    description: "Geometry",
    instructions:
      "Lean about angles, lines of symmetry and shapes on the green planet of Polygonia.",
    playable: true,
    game_type: "geometry",
    rating_background: "Geometry/geometry.gif",
    practice_background: geogame,
    selection_background: "Geometry/menu_geometry.gif",
    service_key: "geometry",
    animation_path: "Geometry/Animation"
  },
  {
    backend_id: 12,
    id: 15,
    image: commetior,
    background: commetior_bg,
    trophies: 20,
    name: "Commetior",
    description: "Measurements",
    instructions:
      "Convert units of length, area, volume, mass and duration and help rebuild the Roman planet.",
    playable: true,
    game_type: "measurement",
    rating_background: "Measurements/measurements.gif",
    practice_background: measurementsgame,
    selection_background: "Measurements/menu_measurements.gif",
    service_key: "measurement",
    animation_path: "Measurements/Animation"
  },

  {
    backend_id: 15,
    id: 19,
    image: abydos,
    background: abydos_bg2,
    trophies: 6,
    name: "Abydos",
    description: "Statistics",
    instructions:
      "Emile has found a deserted planet! Help Emile on a journey to find the lost relics of the statistics crazed lost civilisation.",
    playable: true,
    game_type: "statistics",
    rating_background: "Statistics/statistics.gif",
    practice_background: statisticsgame,
    selection_background: "Statistics/menu_statistics.gif",
    service_key: "statistics",
    animation_path: "Statistics/Animation"
  },
  {
    backend_id: 20,
    id: 17,
    image: algebra,
    background: algebra_screenshot,
    trophies: 2,
    name: "Mechanus",
    description: "Algebra",
    instructions:
      "Help Venici with his designs.",
    playable: true,
    game_type: "algebra",
    rating_background: "Algebra/algebra.gif",
    practice_background: alggame,
    selection_background: "Algebra/menu_algebra.gif",
    service_key: "algebra",
    animation_path: "Algebra/Animation"
  },

  {
    backend_id: 27,
    id: 20,
    image: equitas,
    background: equitas_bg,
    trophies: 22,
    name: "Equitas",
    description: "Ratios and Proportions",
    instructions:
      "Thwart the evil plans of Elime, Scrambler and the dastardly villains of the super-powered planet of Equitas.",
    playable: true,
    game_type: "ratioprop",
    rating_background: "Fractions/fractions.gif",
    practice_background: fractgame,
    selection_background: "Fractions/menu_fractions.gif",
    service_key: "ratioprop",
    animation_path: "Fractions/Animation"
  },
  {
    backend_id: 28,
    id: 30,
    image: caramella,
    background: caramella_screenshot,
    trophies: 2,
    name: "Caramella",
    description: "Maths Vocab",
    instructions:
      "A sweet new planet has been discovered.",
    playable: true,
    game_type: "mvocab",
    rating_background: "Fractions/fractions.gif",
    practice_background: fractgame,
    selection_background: "Fractions/menu_fractions.gif",
    service_key: "mvocab",
    animation_path: "MathsVocab/Animation"
  },
  {
    backend_id: 22,
    id: 23,
    image: numint,
    background: mtc_bg,
    trophies: null,
    name: "Numeracy Intervention",
    description: "Numeracy Intervention",
    instructions: "Try numeracy intervention",
    playable: true,
    game_type: "assessnumeracy",
    game_background: abydos_game_bg,
    selection_background: "background.png",
    service_key: "assessnumeracy"
  },
  {
    backend_id: 29,
    id: 35,
    image: numint,
    background: mtc_bg,
    trophies: null,
    name: "Maths Assessment",
    description: "Maths Assessment",
    instructions: "Try numeracy intervention",
    playable: true,
    game_type: "mathments",
    game_background: abydos_game_bg,
    selection_background: "background.png",
    service_key: "mathments"
  }



];

export default games;
